import React from "react";

import { LoadingIcon as Loading } from "@packages/ds";
import { useIntl } from "react-intl";

import { Button } from "ds/Button";

import * as S from "./SubmitBillingAlertBtn.styles";

type SubmitBillingAlertBtnProps = {
  hasPreviousBillingThreshold;
  billingThreshold: string;
  isBillingAlertLoading: boolean;
  isUpdateLoading: boolean;
  handleUpdateAlert: () => Promise<void>;
};

const SubmitBillingAlertBtn = ({
  isUpdateLoading,
  isBillingAlertLoading,
  hasPreviousBillingThreshold,
  billingThreshold,
  handleUpdateAlert
}: SubmitBillingAlertBtnProps) => {
  const intl = useIntl();

  if (isUpdateLoading && isBillingAlertLoading) {
    return (
      <S.LoadingActionWrapper width={hasPreviousBillingThreshold ? 82 : 130}>
        <Loading />
      </S.LoadingActionWrapper>
    );
  } else {
    const submitBtnText = hasPreviousBillingThreshold
      ? "save"
      : "billing_alerts_modal.submit";

    let disabled = false;
    if (hasPreviousBillingThreshold) {
      disabled = hasPreviousBillingThreshold === billingThreshold;
    }
    if (isBillingAlertLoading) {
      disabled = true;
    }
    return (
      <Button
        type="button"
        aria-label={intl.formatMessage({
          id: submitBtnText
        })}
        onClick={handleUpdateAlert}
        disabled={disabled}
        analyticId={submitBtnText}
      >
        {intl.formatMessage({
          id: submitBtnText
        })}
      </Button>
    );
  }
};

export default SubmitBillingAlertBtn;
